import * as types from './actionTypes';

export function setMainMenuDisplay(displayMainMenu){
    return { type: types.SET_MAIN_MENU_DISPLAY, displayMainMenu };
}



/** WEBPACK FOOTER **
 ** ./src/actions/mainMenuActions.js
 **/